function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "chart");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "chart",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Chart-Copy",
  transform: "translate(-7.000000, -7.000000)",
  stroke: "currentColor",
  strokeWidth: 4
}, React.createElement("g", {
  id: "Chart",
  transform: "translate(32.000000, 32.000000) rotate(45.000000) translate(-32.000000, -32.000000) translate(11.000000, 9.000000)"
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(9.525126, 0.882991)"
}, React.createElement("path", {
  d: "M0.1626896,2.74924892 L10.4649294,14.2986162 L20.9780994,2.90290468 C17.8362005,1.01925589 14.2181623,0 10.44,0 C6.7669559,0 3.24467143,0.96311569 0.1626896,2.74924892 Z",
  id: "Combined-Shape"
})), React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.025126, 9.060660)"
}, React.createElement("path", {
  d: "M6.89884948,0.75148503 C2.55872439,4.5358591 0,9.9768448 0,15.8378378 C0,26.966263 9.1714464,36 20.5,36 C31.8285536,36 41,26.966263 41,15.8378378 C41,10.0830191 38.5338303,4.73107959 34.3288386,0.95322771 L20.475147,15.8638004 L6.89884948,0.75148503 Z",
  id: "Combined-Shape"
})))));

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.321390f1.svg";
export { ForwardRef as ReactComponent };